import { CalendarEvent } from '@gfe/features/components/visualization/calendar/models/calendar.models';

import { VisualizationBuilders } from '@core/models/entities/generic-entity';
import { EntityCfgOverrides } from '@core/models/entities/generic-entity-cfg';
import { CustomData } from '@core/models/entities/implementations/custom-data';
import { QuantifiedExpertise } from '@core/models/entities/implementations/quantified-expertise';
import {
  UserDriverWorkWindowV1Model,
  makeDriverWorkWindowEvent
} from '@core/models/entities/implementations/user-driver-work-window-v1';
import {
  UserEntityRegistrations,
  renderRegistrations
} from '@core/models/entities/implementations/user-entity-registrations';
import { GenericEntityRegistryService } from '@core/services/user-models-registry/generic-entity-registry.service';

export interface UserDriverV1Model {
  uid: string;
  time_zone: string;
  expertises: QuantifiedExpertise[];
  work_windows: UserDriverWorkWindowV1Model[];
  work_regulation_uid?: string;
  company_uid?: string;
  contact_uid?: string;
  registrations?: UserEntityRegistrations;
  custom_data: CustomData;
}

export function registerDriverExtensions(registry: GenericEntityRegistryService): void {
  const overrides: EntityCfgOverrides<UserDriverV1Model> = {
    defaultSortingCol: ['name'],
    availableDetailEntityType: ['driver_schedules'],
    buildColumns: (autoColumns) =>
      autoColumns.map((col) =>
        (col.key as string) === 'raw.registrations'
          ? {
              ...col,
              renderHook: (value: unknown) =>
                value == null ? '' : renderRegistrations(value as UserEntityRegistrations)
            }
          : col
      )
  };
  registry.registerOverrides<UserDriverV1Model>('UserDriver', overrides);

  const builders: VisualizationBuilders<UserDriverV1Model> = {
    buildCalendarEvents: (raw: UserDriverV1Model): CalendarEvent[] =>
      (raw.work_windows ?? []).map((workWindow, index) =>
        makeDriverWorkWindowEvent(raw, workWindow, `${raw.uid}_workwindow_${index}`)
      )
  };
  registry.registerVisualizationBuilders('UserDriver', builders);
}
